import React from 'react'
import Step1Modal from './Step1Modal'
import Step2Modal from './Step2Modal'
import Step3Modal from './Step3Modal'

const Step1 = ({ cookie }) => {
  const { run, type, stepIndex } = cookie
  const isStep1Working = run && ((type == 'edit' && stepIndex > 0) || type == 'show')
  return (
    <React.Fragment>
      {isStep1Working && <Step1Modal cookie={cookie} />}
    </React.Fragment>
  )
}
const Step2 = ({ cookie }) => {
  const { run, type, stepIndex } = cookie
  const isStep2Working = run && ((type == 'create' && stepIndex > 0) || type == 'check')
  return (
    <React.Fragment>
      {isStep2Working && <Step2Modal cookie={cookie} />}
    </React.Fragment>
  )
}
const Step3 = ({ cookie }) => {
  const { run, type, stepIndex } = cookie
  const isStep3Working = run && ((type == 'setInfo' && stepIndex > 0) || type == 'checkInfo')
  return (
    <React.Fragment>
      {isStep3Working && <Step3Modal cookie={cookie} />}
    </React.Fragment>
  )
}

export default { Step1, Step2, Step3 }
